<div class="message-container">
  <h2 *ngIf="!myGroups.length">Your username is not currently associated with any organization.</h2>
  <h2 *ngIf="myGroups.length">
    Your username is not currently associated to a role to access this page.
  </h2>
  <p>Please contact your organization's administrator.</p>
</div>
